module.exports = __webpack_public_path__ + "static/media/SPACE32_profielfoto_Paul.09085dd7.png";